/**
 * Bridges `ThemePreferenceContext` (`auto` | `light` | `dark`) to platform
 * `themePref` (`system` | `light` | `dark`) via the preferences singleton.
 *
 * Application must not import app-kit; this adapter lives in the console.
 */

import type { ThemePreferenceStorage } from '@vectorhub/application'
import { themePref } from '@rammetec/app-kit/preferences'
import { preferencesService } from './preferences.bootstrap'

function toContextMode(raw: 'system' | 'light' | 'dark'): string {
  return raw === 'system' ? 'auto' : raw
}

function toThemePref(raw: string): 'system' | 'light' | 'dark' | null {
  if (raw === 'auto') return 'system'
  if (raw === 'light' || raw === 'dark') return raw
  return null
}

export const themePreferenceStorage: ThemePreferenceStorage = {
  getItem() {
    return toContextMode(preferencesService.get(themePref))
  },
  setItem(_key, value) {
    const mapped = toThemePref(value)
    if (!mapped) return
    // Avoid redundant Firestore writes when hydrate notifies → setModeState
    // re-triggers the ThemePreferenceProvider persist effect with the same value.
    if (preferencesService.get(themePref) === mapped) return
    preferencesService.set(themePref, mapped)
  },
  subscribe(_key, cb) {
    return preferencesService.subscribe(themePref, cb)
  },
}
